import { GraphqlOperations, LocationGroupType } from "@src/types.generated";
import { UserSelectionFilterType } from "./SelectUsersDialog";
import { ReactElement } from "react";
import PinOutlineIcon from "@src/lib/icons/18px/pin-outline";
import IdBadge2OutlineIcon from "@src/lib/icons/18px/id-badge-2-outline";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";
import CopyrightOutlineIcon from "@src/lib/icons/18px/copyright-outline";
import EarthPinOutlineIcon from "@src/lib/icons/18px/earth-pin-outline";
import CodeBranchOutlineIcon from "@src/lib/icons/18px/code-branch-outline";
import CalendarOutlineIcon from "@src/lib/icons/18px/calendar-outline";
import CircleUserFillIcon from "@src/lib/icons/18px/circle-user-fill";

export const ASSIGNMENT_REFETCH_QUERIES = [
  GraphqlOperations.Query.LibraryItemDetailPage_LibraryItem,
  GraphqlOperations.Query.ModuleManageAssignmentsTab_Assignments,
  GraphqlOperations.Query.ModuleManageLibraryAccessTab_Assignments,
  GraphqlOperations.Query
    .PremiumModuleDetailAssignmentsTabContainer_Assignments,
  GraphqlOperations.Query.FoodHandlerDetailAssignmentsTabContainer_Assignments,
  GraphqlOperations.Query.PremiumModuleDetailCertificatesCount,
  GraphqlOperations.Query.PremiumModuleDetailHeader,
  GraphqlOperations.Query.CourseManageTabAssignments,
  GraphqlOperations.Query.ScormCourseManageAssignmentsTab_Assignments,
  GraphqlOperations.Query.CourseDetailHeader,
  GraphqlOperations.Query.AssignmentStatusCounts,
  GraphqlOperations.Query.ComplianceRecords,
  GraphqlOperations.Query.ComplianceSummary,
  GraphqlOperations.Query.CreditBalance,
  GraphqlOperations.Query.UserDetailAssignments,
  GraphqlOperations.Query.UserDetailCompletedTrainingTabAssignments,
  GraphqlOperations.Query.UserPageContentTabCounts,
  GraphqlOperations.Query.OrgPremiumContentConfigs,
  GraphqlOperations.Query.ModuleManageSettingsTab_Module,
  GraphqlOperations.Query.PremiumModuleDetailHeader,
  GraphqlOperations.Query.ModuleManageAssignmentsTab_Assignments,
  GraphqlOperations.Query.PremiumModuleDetailOverview,
  GraphqlOperations.Query.SharpDetailAssignmentsTable_Assignments,
  GraphqlOperations.Query.AssignmentTimelineDialog,
  GraphqlOperations.Query.AssignmentTimelineDialog_AssignmentHistoryItems,
];

export const USER_SELECTION_ICON: {
  [key in UserSelectionFilterType]: ReactElement;
} = {
  locations: <PinOutlineIcon className="size-4 shrink-0" />,
  roles: <IdBadge2OutlineIcon className="size-4 shrink-0" />,
  departments: <UsersOutlineIcon className="size-4 shrink-0" />,
  people: <CircleUserFillIcon className="size-4 shrink-0" />,
  [LocationGroupType.Brand]: (
    <CopyrightOutlineIcon className="size-4 shrink-0" />
  ),
  [LocationGroupType.Region]: (
    <EarthPinOutlineIcon className="size-4 shrink-0" />
  ),
  [LocationGroupType.Franchise]: (
    <CodeBranchOutlineIcon className="size-4 shrink-0" />
  ),
  hireDate: <CalendarOutlineIcon className="size-4 shrink-0" />,
};
